import { validateField } from "./validation";

export const setOnChangeValidation = ($inputElement) => {
  $inputElement.blur((e) => {
    const $el = $(e.currentTarget);
    validateField($el);
  });
};

export const setLocationDropDownOnChange = ($inputElement, $form) => {
  $inputElement.change((e) => {
    const $selectEl = $(e.currentTarget);

    //  set the hidden location id for form that are pre-selected
    $form.find(`input[name=location_id_hidden]`).val($selectEl.val());

    //  automatically set other hidden fields
    //  these are names of the hidden fields of the drop down
    const locationHiddenFields = [
      "location_name",
      "tour_link",
      "location_access_price",
      "location_currency",
      "tour_enterprise_link",
      "tour_link_override",
      "schedule_a_call_link",
    ];

    const options = $selectEl.find(`option[value=${$selectEl.val()}]`).data();

    locationHiddenFields.forEach((name) => {
      $form.find(`input[name=${name}]`).val(options[name]);
    });
  });
};
